
export const SAVE_AND_SUBSCRIBE_MODEL_API_REQUEST: string = 'SAVE_AND_SUBSCRIBE_MODEL_API_REQUEST';
export const SAVE_AND_SUBSCRIBE_MODEL_API_REQUEST_SUCCESS: string = 'SAVE_AND_SUBSCRIBE_MODEL_API_REQUEST_SUCCESS';
export const SAVE_AND_SUBSCRIBE_MODEL_API_REQUEST_FAILURE: string = 'SAVE_AND_SUBSCRIBE_MODEL_API_REQUEST_FAILURE';

export const UNSAVE_AND_UNSUBSCRIBE_MODEL_API_REQUEST: string = 'UNSAVE_AND_UNSUBSCRIBE_MODEL_API_REQUEST';
export const UNSAVE_AND_UNSUBSCRIBE_MODEL_API_REQUEST_SUCCESS: string = 'UNSAVE_AND_UNSUBSCRIBE_MODEL_API_REQUEST_SUCCESS';
export const UNSAVE_AND_UNSUBSCRIBE_MODEL_API_REQUEST_FAILURE: string = 'UNSAVE_AND_UNSUBSCRIBE_MODEL_API_REQUEST_FAILURE';

export interface SaveAndSubscribeModelApiRequest {
	readonly type: 'SAVE_AND_SUBSCRIBE_MODEL_API_REQUEST';
	readonly portfolioId: string;
	readonly origin: string;
}

export interface SaveAndSubscribeModelApiRequestSuccess {
	readonly type: 'SAVE_AND_SUBSCRIBE_MODEL_API_REQUEST_SUCCESS';
	readonly newSaveMapping: Map<string, string>;
	readonly newSubscribeMapping: Map<string, string>;
}

export interface SaveAndSubscribeModelApiRequestFailure {
	readonly type: 'SAVE_AND_SUBSCRIBE_MODEL_API_REQUEST_FAILURE';
	readonly portfolioId: string;
}

export interface UnsaveAndUnsubscribeModelApiRequest {
	readonly type: 'UNSAVE_AND_UNSUBSCRIBE_MODEL_API_REQUEST';
	readonly portfolioId: string;
}

export interface UnsaveAndUnsubscribeModelApiRequestSuccess {
	readonly type: 'UNSAVE_AND_UNSUBSCRIBE_MODEL_API_REQUEST_SUCCESS';
	readonly portfolioId: string;
}

export interface UnsaveAndUnsubscribeModelApiRequestFailure {
	readonly type: 'UNSAVE_AND_UNSUBSCRIBE_MODEL_API_REQUEST_FAILURE';
}

export type SaveAndSubscribeModelPortfoliosAction =
	| SaveAndSubscribeModelApiRequest
	| SaveAndSubscribeModelApiRequestSuccess
	| SaveAndSubscribeModelApiRequestFailure
	| UnsaveAndUnsubscribeModelApiRequest
	| UnsaveAndUnsubscribeModelApiRequestSuccess
	| UnsaveAndUnsubscribeModelApiRequestFailure;
